module.exports = __webpack_public_path__ + "img/DE01364.56716dbe.png";